export default __webpack_public_path__ + "static/media/2.0d3a927e.png";